import { ComplexEnum } from '../../utils/complexEnum'
import { CIMSModuleItem } from '../CIMSModule/CIMSModuleItem'
import {
  CASAdmin,
  CASContractor,
  CASGroupReviewer,
  CASREReviewer,
  CASRoleTemplateItem,
  CASRouter,
} from './instances/cas'
import {
  ConcreteAdmin,
  ConcreteRoleTemplateItem,
  LabConcrete,
} from './instances/concrete'
import {
  DSAdmin,
  DSCloser,
  DSContractor,
  DSGroupReviewer,
  DSRoleTemplateItem,
  DSRouter,
} from './instances/ds'
import {
  EJAdmin,
  EJIssuer,
  EJRoleTemplateItem,
  EJViewOnly,
} from './instances/ej'
import { FDCAdmin, FDCCreator, FDCRoleTemplateItem } from './instances/fdc'
import { IFIReviewer } from './instances/ifi'
import {
  IssueAdmin,
  IssueCloser,
  IssueCreator,
  IssueDispositionGiver,
  IssueResponder,
  IssuesRoleTemplateItem,
} from './instances/issues'
import {
  RFIAdmin,
  RFICreator,
  RFIRoleTemplateItem,
  RFIViewOnly,
} from './instances/rfi'

export type RoleTemplateItem =
  | CASRoleTemplateItem
  | ConcreteRoleTemplateItem
  | DSRoleTemplateItem
  | EJRoleTemplateItem
  | FDCRoleTemplateItem
  | typeof IFIReviewer
  | IssuesRoleTemplateItem
  | RFIRoleTemplateItem

class RoleTemplateEnum extends ComplexEnum<
  'RoleTemplate',
  RoleTemplateItem,
  RoleTemplateItem['id']
> {
  readonly typename = 'RoleTemplate'
  readonly CASAdmin = CASAdmin
  readonly CASContractor = CASContractor
  readonly CASGroupReviewer = CASGroupReviewer
  readonly CASREReviewer = CASREReviewer
  readonly CASRouter = CASRouter
  readonly ConcreteAdmin = ConcreteAdmin
  readonly DSAdmin = DSAdmin
  readonly DSCloser = DSCloser
  readonly DSContractor = DSContractor
  readonly DSGroupReviewer = DSGroupReviewer
  readonly DSRouter = DSRouter
  readonly EJAdmin = EJAdmin
  readonly EJIssuer = EJIssuer
  readonly EJViewOnly = EJViewOnly
  readonly FDCAdmin = FDCAdmin
  readonly FDCCreator = FDCCreator
  readonly IFIReviewer = IFIReviewer
  readonly IssueAdmin = IssueAdmin
  readonly IssueCloser = IssueCloser
  readonly IssueCreator = IssueCreator
  readonly IssueDispositionGiver = IssueDispositionGiver
  readonly IssueResponder = IssueResponder
  readonly LabConcrete = LabConcrete
  readonly RFIAdmin = RFIAdmin
  readonly RFICreator = RFICreator
  readonly RFIViewOnly = RFIViewOnly

  get values() {
    return [
      this.CASAdmin,
      this.CASContractor,
      this.CASGroupReviewer,
      this.CASREReviewer,
      this.CASRouter,
      this.ConcreteAdmin,
      this.DSAdmin,
      this.DSCloser,
      this.DSContractor,
      this.DSGroupReviewer,
      this.DSRouter,
      this.EJAdmin,
      this.EJIssuer,
      this.EJViewOnly,
      this.FDCAdmin,
      this.FDCCreator,
      this.IFIReviewer,
      this.IssueAdmin,
      this.IssueCloser,
      this.IssueCreator,
      this.IssueDispositionGiver,
      this.IssueResponder,
      this.LabConcrete,
      this.RFIAdmin,
      this.RFICreator,
      this.RFIViewOnly,
    ]
  }

  /**
   * gathers all role templates for the supplied module
   *
   * @param module {@link CIMSModuleItem}
   */
  findByModule(module: CIMSModuleItem) {
    return this.values.filter(
      ({ module: roleModule }) => roleModule.id === module.id
    )
  }
}

export const RoleTemplate = new RoleTemplateEnum()
